import { createAction } from 'redux-actions';

import { UnsubscribeFilterObjectType } from '@ts/unsubscribes.types';

export const setFiltersForUnsubscribes = createAction<UnsubscribeFilterObjectType>(
  'SET_FILTERS_FOR_UNSUBSCRIBES'
);
export const throwFiltersForUnsubscribes = createAction<void>('THROW_FILTERS_FOR_UNSUBSCRIBES');
